import { AppButton } from '../../../forms';
import { MicrosoftOfficeExcelLogo } from '../../../icons';

export interface ISampleDownloadFileProps {
  sampleDownloadLink: string;
}

/**
 * -----------------------------------------------------------------------------
 * It renders the sample download file with a download button
 */
export function SampleDownloadFile({
  sampleDownloadLink,
}: Readonly<ISampleDownloadFileProps>) {
  const handleOnDownloadClick = () => {
    window.open(sampleDownloadLink, '_blank');
  };

  return (
    <div
      className="
        flex flex-col items-center gap-10 rounded-2xl border
        border-gray-100 px-5 py-3 sm:flex-row
      "
    >
      <div>
        <div className="flex items-center gap-4">
          <MicrosoftOfficeExcelLogo className="w-5" />
          <div className="text-base font-medium text-gray-900">
            Sample Quote
          </div>
        </div>
        <p className="max-w-xs pt-1.5 text-xs text-gray-900">
          <span className="me-1">
            You can download this sample file and use it as a starting point for
            the quote
          </span>
          <b>(max 5 MB)</b>
        </p>
      </div>
      <div>
        <AppButton
          onClick={handleOnDownloadClick}
          size="small"
          title="Download"
          type="outlined"
          variants="default"
        />
      </div>
    </div>
  );
}
